// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html,\nbody .app {\n  color: #333333;\n  background-color: #f8f8f8;\n  height: 100%;\n}\n\n.app-container {\n  padding-bottom: 1.33333rem;\n}", ""]);
// Exports
module.exports = exports;
